import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Titre',
      placeholder: 'Saisir le titre de la notification',
    },
    body: {
      label: 'Corps du message',
      placeholder: 'Saisir votre message',
    },
    promo_code: {
      label: 'Code promo',
      placeholder: 'Sélectionner un code promo',
    },
    offers: {
      label: 'Offres',
      placeholder: 'Sélectionner une offre',
    },
    campaign_type: {
      label: 'Type de campagne',
      placeholder: 'Sélectionner le type de campagne',
    },
    tone: {
      label: 'Ton de communication',
      placeholder: 'Sélectionner un ton',
    },
  },
  attachment: {
    heading: 'Que doit promouvoir cette campagne ?',
    offer: {
      title: 'Offre',
      description: 'Choisissez parmi vos offres actives.',
    },
    promo_code: {
      title: 'Code promo',
      description: 'Choisissez parmi vos codes promo actifs.',
    },
  },
  buttons: {
    generate: 'Générer',
    improve: "Améliorer avec l'IA",
    undo: 'Annuler ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Amical 🙂',
    [ToneTypes.Elegant]: 'Élégant ✨',
    [ToneTypes.Playful]: 'Ludique 🎉',
    [ToneTypes.Professional]: 'Professionnel 👨‍💼',
    [ToneTypes.Informative]: 'Informatif 📊',
    [ToneTypes.Persuasive]: 'Persuasif 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promotionnel 🚀',
    [CampaignTypes.Informational]: 'Informationnel ℹ️',
  },
  no_promo_codes: {
    title: 'Aucun code promo éligible',
    description: 'Créez un nouveau code promo.',
    create_promo_code: 'Créer un code promo',
  },
  no_offers: {
    title: 'Aucune offre active',
    description: 'Créez une nouvelle offre.',
    create_offer: 'Créer une offre',
  },
  feedback: {
    success: 'Généré avec succès',
    error: 'Échec de la génération',
  },
};
